<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input v-model="keyword" placeholder="请输入bus_app_id" @keyup.enter.native="getUsers"></el-input>
         <el-input v-model="stage" placeholder="请输入stage"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.bus_app_id }}</span>
        </template>
      </el-table-column>

      <el-table-column label="时间" width="">
        <template slot-scope="scope">
          <span>{{scope.row.created_at | formatDate}}</span>
        </template>
      </el-table-column>

      <el-table-column label="详情" width="">
        <template slot-scope="scope">
         <a href="#" v-on:click="examine()">查看</a>
        </template>
      </el-table-column>

      <el-table-column label="日期" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.plan_repay_date }}</span>
        </template>
      </el-table-column>

      <el-table-column label="stage" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.stage }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 弹层展示页 -->
    <div id="changes" v-show="ischange" >
       <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.appId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="guaranteedFee" width="">
        <template slot-scope="scope">
          <span>{{scope.row.datas.guaranteedFee}}</span>
        </template>
      </el-table-column>
      <el-table-column label="interest" width="">
        <template slot-scope="scope">
        <span>{{scope.row.datas.interest}}</span>
        </template>
      </el-table-column>

      <el-table-column label="manageFee" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.manageFee }}</span>
        </template>
      </el-table-column>

      <el-table-column label="overdueFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.overdueFee }}</span>
        </template>
      </el-table-column>
      <el-table-column label="pettyCashFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.pettyCashFee }}</span>
        </template>
      </el-table-column>
      <el-table-column label="planRepDate" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.planRepDate }}</span>
        </template>
      </el-table-column>
       <el-table-column label="principal" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.principal }}</span>
        </template>
      </el-table-column>
       <el-table-column label="punishAmt" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.punishAmt }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayGuaranteedFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayGuaranteedFee }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayInterest" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayInterest }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayManageFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayManageFee }}</span>
        </template>
      </el-table-column>
      <el-table-column label="repayOverdueFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayOverdueFee }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayPettyCashFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayPettyCashFee }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayPrincipal" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayPrincipal }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayPunish" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayPunish }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayRisk" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayRisk }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayServiceFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayServiceFee }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayStatus" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayStatus}}</span>
        </template>
      </el-table-column>
       <el-table-column label="repaySupportFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repaySupportFee }}</span>
        </template>
      </el-table-column>
       <el-table-column label="repayType" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.repayType }}</span>
        </template>
      </el-table-column>
       <el-table-column label="riskAmt" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.riskAmt }}</span>
        </template>
      </el-table-column>
       <el-table-column label="serviceFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.serviceFee }}</span>
        </template>
      </el-table-column>
         <el-table-column label="stage" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.stage }}</span>
        </template>
      </el-table-column>
         <el-table-column label="supportFee" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.supportFee }}</span>
        </template>
      </el-table-column>
         <el-table-column label="uniqueid" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.uniqueid }}</span>
        </template>
      </el-table-column>
          <el-table-column label="violateAmt" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.violateAmt }}</span>
        </template>
      </el-table-column>
     </el-table>
    </div>
    <!-- 弹层 -->
    <div class="masklayer" id="mask" v-show="mask" style="height: 995px;">
      <span class="cross" v-on:click="cross()">关闭</span>
    </div>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
    import { RepaymentChange } from '../../api/api';
    import { formatDate } from '../../utils/utils.js';
    export default {
      // created() {
      //   this.listLoading = true;
      //   //get list
      //   RepaymentChange()
      //     .then((res) => {
      //       if(res.status === 0){
      //         this.contracts = res.data.data;
      //         this.total_count = res.data.total_count;
      //         this.listLoading = false;
      //         if(res.data.total_pages < 2){
      //           this.pagination = false;
      //         }
      //       }
      //     })
      // },

      //时间转换
       filters: {
        formatDate(time) {
            return formatDate(time, 'yyyy-MM-dd hh:mm');
        }
    },
      // beforeRouteUpdate(to, from, next) {
      //   this.listLoading = true;
      //   //get list
      //   RepaymentChange(to.query)
      //     .then((res) => {
      //       if(res.status === 0){
      //         this.contracts = res.data.data;
      //         this.total_count = res.data.total_count;
      //         this.listLoading = false;
      //         if(res.data.total_pages < 2){
      //           this.pagination = false;
      //         }
      //       }
      //     })
      // },
      data() {
        return {
          keyword: '',
          stage:'',
          mask:false,
          ischange:false,
          //===有分页会用到
          currentPage: 1,
          listLoading: false,
          total_count: 0,
          pagination: true,
          //=====
           contracts: [],
           dataContent:[]

        }
      },
      methods: {
        getUsers() {
          let params = {
            'bus_app_id': this.keyword,
             'stage':     this.stage,
             //'page':      this.currentPage
          };
          RepaymentChange(params).then((res) => {
            if(res.status === 0){
              this.contracts = res.data.change_logs;
              this.total_count =res.data.change_logs.length;
              // if(res.data.total_pages < 2){
              //   this.pagination = false;
              // }else {
              //   this.pagination = true;
              // }
            }
          })
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.getUsers();
        },
        examine:function(){
          this.mask =! this.mask;
         this.ischange =! this.ischange;
        },
         cross:function(){
           this.mask = false;
           this.ischange =false;
        }
      }
    }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/RepaymentChange.vue